<template>
  <div data-scroll-container>
    <slot />
  </div>
</template>

<script>
import LocomotiveScroll from "locomotive-scroll";

export default {
  name: "SmoothScrollTimeline",
  data() {
    return {
      Loco: "",
      windowWidth: window.innerWidth,
      windowHeight: window.innerHeight,
      toRotate: true,
      scrolled: false,
      prevScroll: 0,
      is_trackpad: false,
      current_pos: 0,
      old_pos_sm: 0,
    };
  },
  created: function() {},
  mounted() {
    this.$nextTick(function() {
      this.initLocoScroll();
      window.addEventListener("resize", this.onResize);
    });
    
// setInterval(() => {
//       this.checkScroll();
//     }, 300);
    // setInterval(() => {
    //   // console.log(this.Loco)
    // }, 1000/60);
    if(this.windowWidth >= 1024){

  
           let old_pos = 0;
       

        setInterval(() => {
          // this.scrolled = true;
            let ev =   this.Loco.scroll.instance;
          let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");
          let _v = (this.current_pos - old_pos) * 0.15;
          let v = ((this.current_pos - old_pos) * 0.15);
         if(_v > 4 ){
           _v = 4;
         }
            if(v < -4 && v !== 0 ){
           v = -4;
         }
                    if(   ev.direction == "right"  &&
        window.innerWidth >= 1024){
             imgs.forEach(img => {
          img.style.transform = `rotate(${_v}deg) scale(1)`;
          // console.log(_v)
        });
        } else {
          if( ev.direction == "left" &&
        window.innerWidth >= 1024){
                   imgs.forEach(img => {
          img.style.transform = `rotate(${v}deg) scale(1)`;
          // console.log(v)
        });
        }
        }
                      if(old_pos !== this.current_pos){
           this.scrolled = false;
           old_pos = 0;
          //  console.log(this.scrolled)
            
            // console.log(old_pos)
            // console.log(this.current_pos)
          } else {
            this.scrolled = true;
          }
          // console.log(old_pos)
          old_pos = this.current_pos;
          
          // console.log(this.current_pos)
  
        }, 1000/60);
          } else if(this.windowWidth >= 768 && this.windowWidth <= 1023) {
           this.old_pos_sm = window.pageYOffset;
          this.current_pos = window.pageYOffset;
          

        // this.sm_req();
        window.requestAnimationFrame(this.sm_req)
          }
    if(this.windowWidth >= 768 && this.windowWidth <= 1023){

      
    // document.addEventListener("wheel", e => {
      // this.scrolled
      this.scrolled = true;
      this.is_trackpad = false;
      let trackpad_val;
                      // console.log(e.deltaY)

                  // if (e.wheelDeltaY) {
                  //   if (Math.abs(e.wheelDeltaY) !== 120) {

                  //    this.is_trackpad = true;
                  //     trackpad_val = e.wheelDeltaY;
                  //   }
                  // }
                  // else if (e.deltaMode === 0) {
                  // this.is_trackpad = true;
                  //     trackpad_val = Math.abs(e.wheelDeltaY);

                  //                         // console.log(e.wheelDeltaY)

                  // }
                  // console.log(is_trackpad ? "Trackpad detected" : "Mousewheel detected");
                  // console.log(trackpad_val);
      // this.scrolled = this.is_trackpad ? false : true;

     
     
    
      
      // let ev = this.Loco.scroll.instance;
      // let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");
       
      // if (
      //   ev.direction == "right" &&
      //   ev.delta.x !== ev.limit.x &&
      //   ev.delta.x !== 0 &&
      //   window.innerWidth >= 1024
      // ) {
      //   // imgs.forEach(img => {
      //   //   img.style.transform = `rotate(3deg) scale(0.9)`;
      //   // });
      
      // } else if (
      //   ev.direction == "left" &&
      //   ev.delta.x !== ev.limit.x &&
      //   ev.delta.x !== 0 &&
      //   window.innerWidth >= 1024
      // ) {
      //   // imgs.forEach(img => {
      //   //   img.style.transform = `rotate(-3deg) scale(0.9)`;
      //   // });
      // }

      // if (
      //   ev.direction == "down" &&
      //   ev.delta.y !== ev.limit.y &&
      //   ev.delta.y !== 0 &&
      //   window.innerWidth <= 1023
      // ) {
      //   imgs.forEach(img => {
      //     img.style.transform = `rotate(3deg) scale(0.9)`;
      //   });
      // } else if (
      //   ev.direction == "up" &&
      //   ev.delta.y !== ev.limit.y &&
      //   ev.delta.y !== 0 &&
      //   window.innerWidth <= 1023
      // ) {
      //   imgs.forEach(img => {
      //     img.style.transform = `rotate(-3deg) scale(0.9)`;
      //   });
      // }
      //       this.scrolled = false;
     
    // });

    // document.addEventListener("touchmove", e => {
    //   this.scrolled = true;
    //   let ev = this.Loco.scroll.instance;
    //   let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");

    //   if (
    //     ev.direction == "right" &&
    //     ev.delta.x !== ev.limit.x &&
    //     ev.delta.x !== 0 &&
    //     window.innerWidth >= 1024
    //   ) {
    //     imgs.forEach(img => {
    //       img.style.transform = `rotate(3deg) scale(0.9)`;
    //     });
    //   } else if (
    //     ev.direction == "left" &&
    //     ev.delta.x !== ev.limit.x &&
    //     ev.delta.x !== 0 &&
    //     window.innerWidth >= 1024
    //   ) {
    //     imgs.forEach(img => {
    //       img.style.transform = `rotate(-3deg) scale(0.9)`;
    //     });
    //   }

    //   if (
    //     ev.direction == "down" &&
    //     ev.delta.y !== ev.limit.y &&
    //     ev.delta.y !== 0 &&
    //     window.innerWidth <= 1023
    //   ) {
    //     imgs.forEach(img => {
    //       img.style.transform = `rotate(3deg) scale(0.9)`;
    //     });
    //   } else if (
    //     ev.direction == "up" &&
    //     ev.delta.y !== ev.limit.y &&
    //     ev.delta.y !== 0 &&
    //     window.innerWidth <= 1023
    //   ) {
    //     imgs.forEach(img => {
    //       img.style.transform = `rotate(-3deg) scale(0.9)`;
    //     });
    //   }
    // });
  
     }
  },
  computed: {
    updateOnLoad() {
      return this.$store.state.main.current_content_request_status;
    }
  },
  watch: {
    Loco() {
      this.Loco.update();
    },
    scrolled(ns, os){
      // console.log(ns)
             let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");
        let ev = this.Loco.scroll.instance;
      if(ns == true){
        // console.log(imgs)
        // imgs.forEach(img => {
        //   img.style.transform = "rotate(0deg) scale(1)";
        // });
        
      } else {
        // if(   ev.direction == "right" &&
        // ev.delta.x !== ev.limit.x &&
        // ev.delta.x !== 0 &&
        // window.innerWidth >= 1024){
        //      imgs.forEach(img => {
        //   img.style.transform = `rotate(3deg) scale(0.9)`;
        // });
        // } else {
        //   if( ev.direction == "left" &&
        // ev.delta.x !== ev.limit.x &&
        // ev.delta.x !== 0 &&
        // window.innerWidth >= 1024){
        //            imgs.forEach(img => {
        //   img.style.transform = `rotate(-3deg) scale(0.9)`;
        // });
        // }
        // }
           
      }
      
    },
    is_trackpad(ns, os){
      console.log(ns)
      // if(ns == true){
      //   let old_pos = 0;
      //   setInterval(() => {
      //     if(old_pos == this.current_pos){
      //       this.scrolled =  true;
      //       console.log(old_pos)
      //       console.log(this.current_pos)
      //     }
      //     old_pos = this.current_pos;
      //   }, 1000/60);
      // }
    }
  },
  methods: {
    sm_req(){
        // this.scrolled = true;
          // console.log('ksakldaskl')
              // console.log(window.pageYOffset)

          this.current_pos = window.pageYOffset;
            let ev =   this.Loco.scroll.instance;
          let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");
          let _v = (this.current_pos - this.old_pos_sm) * 0.15;
          let v = ((this.current_pos - this.old_pos_sm) * 0.15);
         if(_v > 3.0 ){
           _v = 3.0;
         } else if (_v  < -3.0 && _v !== 0){
           _v  = -3.0;
         }
        //     if(v < -1.5 && v !== 0 ){
        //    v = -1.5;
        //  console.log(v)

        //  }
                    if( document.body.offsetHeight !== this.current_pos  ){
             imgs.forEach(img => {
          img.style.transform = `rotate(${_v}deg) scale(1)`;
          // console.log(_v)
        });
        } else {
          if(this.current_pos !== 0){
                   imgs.forEach(img => {
          // img.style.transform = `rotate(${v}deg) scale(1)`;
          // console.log(v)
        });
        }
        }
                      if(this.old_pos_sm !== this.current_pos){
           this.scrolled = false;
          this.old_pos_sm = 0;
          //  console.log(this.scrolled)
            
            // console.log(old_pos)
            // console.log(this.current_pos)
          } else {
            this.scrolled = true;
          }
          // console.log(old_pos)
          this.old_pos_sm = this.current_pos;
          window.requestAnimationFrame(this.sm_req);
          // console.log(this.current_pos)
  
        // }, 1000/60);
    },
    checkScroll() {
      if(!this.is_trackpad){

     
      if (this.scrolled) {
        this.scrolled = false;
      }
      if (!this.scrolled) {
        let imgs = document.querySelectorAll(".timeline__block .rot__wrapper");

        imgs.forEach(img => {
          img.style.transform = "rotate(0deg) scale(1)";
        });
      }
       }
    },
    initLocoScroll() {
      this.Loco = new LocomotiveScroll({
        el: document.querySelector("[data-scroll-container]"),

        direction: "horizontal",

        multiplier: 1.2,
        smooth: true,
        touchMultiplier: 6,
        firefoxMultiplier: 52,
        gestureDirection: "both",
        getDirection: true,
        getSpeed: true,
        lerp: 0.12,
        initPosition: {
          x: 0,
          y: 0
        },
        tablet: {
          smooth: true,
           direction: "horizontal",

          breakpoint: 1024
        },
        smartphone: {
          breakpoint: 767,
          smooth: false,
          direction: "vertical"
        }
      });
  if(window.innerWidth >= 1024){
       this.Loco.on('scroll', (e) => {
    //  console.log(e.scroll.x);
     this.current_pos = e.scroll.x;
   })
 
      setTimeout(() => {
        this.Loco.update();
      }, 600);

      console.log("init");
       }
    },
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
      this.Loco.update();
    },
    scrollStatus() {}
  },
  beforeDestroy() {
      window.removeEventListener("resize", this.onResize);

    this.Loco.destroy();
  }
};
</script>

<style>
.custom-scroll {
  height: 100vh;
  overflow: auto;
}
</style>

<style lang="scss">
@keyframes rot-wrapper {
  0% {
    transform: rotate(0) scale(1);
  }
  20% {
    transform: rotate(-3deg) scale(0.9);
  }

  100% {
    transform: rotate(0) scale(1);
  }
}

@keyframes rot-wrapper-left {
  0% {
    transform: rotate(0) scale(1);
  }
  20% {
    transform: rotate(3deg) scale(0.9);
  }

  100% {
    transform: rotate(0) scale(1);
  }
}
</style>
